import { MarketplaceGallery as MarketplaceGalleryCmp } from './MarketplaceGallery'
import React from 'react'
import { Spacer } from '@vestaboard/installables'

export const MarketplaceGallery = () => {
  return (
    <>
      <MarketplaceGalleryCmp isNote={false} />
      <Spacer size='extraLarge' />
      <MarketplaceGalleryCmp isNote={true} />
    </>
  )
}
